import JsonBigint from "json-bigint";

const REQUEST_TIMEOUT_SEC = 60000

export async function callDalleService(backendUrl, text, numImages) {
    const queryStartTime = new Date()
    const response = await Promise.race([
        (await fetch(backendUrl + `/dalle`, {
                method: 'POST',
                headers: {
                    'Bypass-Tunnel-Reminder': "go",
                    'mode': 'no-cors'
                },
                body: JSON.stringify({
                    text,
                    'num_images': numImages,
                })
            }
        ).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response
        })).text(), new Promise((_, reject) => setTimeout(
            () => reject(new Error('Timeout')), REQUEST_TIMEOUT_SEC))
    ]);


    return {
        'executionTime': Math.round(((new Date() - queryStartTime) / 1000 + Number.EPSILON) * 100) / 100,
        'generatedImgs': JsonBigint.parse(response)
    }
}

export async function checkIfValidBackend(backendUrl) {
    return await fetch(backendUrl, {
        headers: {
            'Bypass-Tunnel-Reminder': "go",
            'mode': 'no-cors'
        }
    }).then(function (response) {
        return true
    }).catch(() => {
        return false
    })
}
